import '../../assets/init'


import "chartkick/chart.js"

import intlTelInput from "intl-tel-input";
import "intl-tel-input/styles";

function initPhoneInput() {
  const input = document.querySelector("#phone_number_display");
  if (!input || input.dataset.itiInitialized) return; // guard vs turbo re-init
  input.dataset.itiInitialized = "true";

  const hidden = document.querySelector("#phone_number_hidden");

  const iti = intlTelInput(input, {
    initialCountry: "gh",
    separateDialCode: true,
    loadUtils: () => import("intl-tel-input/utils"),
  });

  if (hidden.value) iti.setNumber(hidden.value);

  input.form.addEventListener("submit", (e) => {
    const errorEl = document.querySelector("#phone_number_error");
    if (!iti.isValidNumber()) {
      e.preventDefault();
      errorEl?.classList.remove("hidden");
      return;
    }
    errorEl?.classList.add("hidden");
    hidden.value = iti.getNumber();
  });
}

document.addEventListener("turbo:load", initPhoneInput);




// Import JS and CSS from view_components
import.meta.glob('../../components/**/*.js', { eager: true })
import '../../components/resource_form/dropdown_component_controller.ts'
import '../../assets/controllers/header_menu_controller.js'
import.meta.glob('../../components/**/*.css', { eager: true })
import.meta.glob('../../assets/controllers/**/*_controller.{js,ts}', { eager: true })
